import { HCConfig, HCConfigAssets, HCConfigFeatures, HCConfigRules } from './hc-config';

export const saoPaulo: HCConfig = {
         appName: 'Telessaúde São Paulo',
         hcId: '',
         isPublic: true,
         uf: 'sp',
         config: {
           trackingId: 'G-1234567890', // needs to be changed later
           domain: 'app.hcsampa.com.br',
           hcParam: 'sao-paulo',
           domainKey: 'appSaoPauloDomainUrl',
           reactDomainKey: 'appSaoPauloDomainReactUrl',
           clientDomainHeader: 'HC-SAMPA',
           clientDomain: 'HC-SAMPA',
           govBrClientId: 'cuidar-piaui-gov-pi',
           supportChatKey: 'foo-test-1234567890-test-key', // needs to be changed later
         },

         assets: {
           logo: HCConfigAssets.mainLogo('sao-paulo'),
           uploadExternalFilesLogo: HCConfigAssets.uploadExternalFilesLogo('sao-paulo'),
           preloaderLogo: HCConfigAssets.preloaderLogo('sao-paulo'),
           favicon: HCConfigAssets.favicon('sao-paulo'),
         },

         links: {
           site: 'https://app.hcsampa.com.br',
           termsOfUse: 'https://hcsampa.com.br/termos-de-uso-sao-paulo.html',
           policyPrivacy: 'https://hcsampa.com.br/politica-de-privacidade-sao-paulo.html',
           playstore: 'https://play.google.com/store/apps/details?id=com.ptm.sampa', // needs to be changed later
           appstore: 'https://apps.apple.com/br/app/sampa-saude-digital/id6742512883', // needs to be changed later
         },

         dataDeletion: {
           name: 'Telessaúde São Paulo',
           slug: 'sao-paulo',
           agreementTermsUrl: 'https://hcsampa.com.br/termo-de-consentimento-exclusao-conta-sao-paulo.html',
           background: '#ffffff',
           logo: {
             src: HCConfigAssets.dataDeletionLogo('sao-paulo'),
             width: 137,
             height: 180,
           },
         },

         firstAccess: {
           name: 'Telessaúde São Paulo',
           abbreviation: 'sp',
           emailDomain: '@hcsampa.com.br',
           slug: 'sao-paulo',
           city: 'São Paulo',
           background: 'linear-gradient(45deg, #2d8efb, #034ea2 35%, #023f82)',
           logo: {
             src: HCConfigAssets.firstAccessLogo('sao-paulo'),
             width: 115,
             height: 150,
           },
         },

         mealPlan: {
           enableDocumentCreation: false,
           enableSendFiles: true,
           documentTypes: {
             showMealPlan: true,
             showTherapeuticPlan: false,
             showNursingPlan: false,
           },
         },

         routes: {
           firstAccess: '/first-access/sao-paulo',
         },

         features: [
           HCConfigFeatures.PROCEDURES_APAC_SADT,
           HCConfigFeatures.REFERRAL_GUIDE,
           HCConfigFeatures.REQUEST_ATTENDANCE,
           HCConfigFeatures.HC_ADM_CAN_CHANGE_PATIENT_PASSWORD,
           HCConfigFeatures.PATIENT_COMPLEMENTARY_DATA_FORM_INCLUDE_PHONE,
           HCConfigFeatures.PATIENT_INVITE_AND_EDIT_FORM_INCLUDE_EXTERNAL_ID,
           HCConfigFeatures.CAMERA_MIC_PREVIEW_BEFORE_CALL_JOIN,
         ],
         rules: [
           HCConfigRules.PATIENT_COMPLEMENTARY_DATA_FORM_DISABLE_CPF,
           HCConfigRules.PATIENT_COMPLEMENTARY_DATA_FORM_REQUIRE_PHONE,
           HCConfigRules.PATIENT_INVITE_AND_EDIT_FORM_REQUIRE_CPF,
           HCConfigRules.PATIENT_INVITE_AND_EDIT_FORM_REQUIRE_EXTERNAL_ID,
           HCConfigRules.APPOINTMENT_MANAGEMENT,
           HCConfigRules.PHYSICIAN_SIGNATURE_STATUS_WIDGET,
           HCConfigRules.DOCTORS_LIST_SHOW_DIGITAL_SIGNATURE_STATUS,
         ],
       };
